import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.FranchiseeQuoteSupportTicketView.';

  public static readonly close = `${Id.prefix}close`;
  public static readonly discard = `${Id.prefix}discard`;
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
  public static readonly newSupportRequest = `${Id.prefix}newSupportRequest`;
  public static readonly supportRequest = `${Id.prefix}supportRequest`;
}

export class LangFranchiseeQuoteSupportTicketView {
  private constructor() {}

  public static close(): string {
    return interpolate(Id.close);
  }
  public static discard(): string {
    return interpolate(Id.discard);
  }
  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }
  public static newSupportRequest(): string {
    return interpolate(Id.newSupportRequest);
  }
  public static supportRequest(): string {
    return interpolate(Id.supportRequest);
  }
}

export class FranchiseeQuoteSupportTicketViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.close, 'Close', 'Button label for closing the dialog');
    register.add(Id.discard, 'Discard', 'Button label for discarding a new support request');
    register.add(
      Id.discardChanges,
      'Discard Changes',
      'Button label for discarding changes to an existing support request'
    );
    register.add(Id.newSupportRequest, "New {{glossary 'support-request'}}", 'Caption for a new support request');
    register.add(Id.supportRequest, "{{glossary 'support-request'}}", 'Caption for an existing support request');
  }
}
